<div class="distance-azimuth" [ngClass]="this.distanceAzimuthService.active? 'active' : ''">
  <div class="distance-azimuth__container">
  </div>
</div>
